import { Platform } from 'react-native';
import * as FileSystem from 'expo-file-system/legacy';
import { fileMimeType } from './formFilePolicy';

/**
 * Converts a picked document/image asset into the submission shape
 * `{ filename, mimeType, base64, size }`. Reads the file content as base64 on
 * both web (via fetch + FileReader) and native (via expo-file-system).
 * Shared by file-answer fields and form-resource uploads.
 */
const assetToSubmission = async (asset) => {
    const filename = asset.name || asset.filename || 'file';
    const mimeType = fileMimeType(asset);
    const size = asset.size ?? 0;

    let base64 = '';
    if(Platform.OS === 'web'){
        const response = await fetch(asset.uri);
        const blob = await response.blob();
        base64 = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const result = reader.result || '';
                // strip the `data:*/*;base64,` prefix
                const commaIdx = result.indexOf(',');
                resolve(commaIdx >= 0 ? result.slice(commaIdx + 1) : result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } else {
        base64 = await FileSystem.readAsStringAsync(asset.uri, {
            encoding: FileSystem.EncodingType.Base64,
        });
    }

    return { filename, mimeType, base64, size };
};

export { assetToSubmission };
